import { C } from 'jssip'
import { isCSV2 } from 'modules/Helpers'

const department = 'deptname'
const welcomeMenu = 'menuname'
const ringGroup = 'rgname'
const user = 'callinguser'
const incoming = 'incoming'
const outgoing = 'outgoing'

const decline = 603

const sessions = {
  entities: {
    list: [department, welcomeMenu, ringGroup, user],
    names: { department, welcomeMenu, ringGroup, user },
  },
  direction: { incoming, outgoing },
  options: {
    decline: {
      status_code: decline,
      reason_phrase: C.REASON_PHRASE[decline], // this is mapped by default in JsSIP
    },
  },
  hidden: {
    unavailable: 'Unavailable',
    restricted: 'Restricted',
    anonymous: 'anonymous',
  },
}
export const REASON = {
  header: 'Reason',
  headerKey: 'SIP',
  key: 'cause',
  value: '200',
  parked: {
    key: 'text',
    value: 'call parked',
    slotKey: 'slot',
  },
}
export const DIRECTIONS = [incoming, outgoing]
export const ENTITIES_MAP = {
  [department]: 'department',
  [ringGroup]: 'ringGroup',
  [user]: 'teamMember',
  [welcomeMenu]: 'welcomeMenu',
}
export const SETUP_TYPE = {
  PASSIVE: 'a=setup:passive',
  ACTPASS: 'a=setup:actpass',
}
export const MESSAGE_TYPE = { OFFER: 'offer', ANSWER: 'answer' }
export const ORIGIN = { REMOTE: 'remote', LOCAL: 'local' }
export const HEADER_ENTITIES = [department, welcomeMenu, ringGroup, user]
export const CUSTOM_HEADER = 'P-Idt-Webrtc'
export const SHOW_MISSED_HEADER = 'displayMissedCall'
export const REFER_CODES = {
  PARK: {
    ACTION: 'park',
    CODE: '*4',
  },
  TRANSFER_TO_VOICEMAIL: {
    ACTION: 'voicemail',
  },
}
Object.defineProperty(REFER_CODES.TRANSFER_TO_VOICEMAIL, 'CODE', {
  get() {
    return isCSV2() ? '*3' : '#3'
  },
})

export default sessions
